import { Fragment, useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import { Breadcrumbs } from "AbstractElements";
import TheForm from "Components/Common/Component/form/TheForm";
import { useCrudApi } from "hook/useCrudApi";
import { useResourceNavigate } from "hook/useResourceNavigate";
import { HoSoCaNhan } from "models/ho-so-ca-nhan";
import { useForm } from "react-hook-form";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { useFormFields, parent, title } from "./constant";

export const EditPage = () => {
  const { useUpdate, useGetById } = useCrudApi<HoSoCaNhan>("HoSoCaNhan");
  const { toList } = useResourceNavigate("ho-so-ca-nhan");

  const { id } = useParams();

  const { data, isFetched } = useGetById(id ?? "");

  const useFormReturn = useForm();
  const { reset, handleSubmit } = useFormReturn;
  const formFields = useFormFields(useFormReturn);

  const { mutate } = useUpdate({
    onSuccess: (data) => {
      toast.success(`Cập nhật thành công cho: ${data.hoTen}`);
      toList();
    },
    onError: (error) => {
      toast.error(`Lỗi: ${error.message}`);
    },
  });

  const onSubmit = (values) => {
    mutate({ ...values, gioiTinh: Boolean(+values.gioiTinh) });
  };

  useEffect(() => {
    reset({ ...data, gioiTinh: +(data?.gioiTinh || 0) });
  }, [data, isFetched]);

  return (
    <Fragment>
      <Breadcrumbs title={title} parent={parent} mainTitle={title} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <TheForm
                  {...useFormReturn}
                  items={formFields as any}
                  onSubmit={handleSubmit(onSubmit)}
                  onCancel={toList}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
